/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  SET_ADD_EP_PAX,
  SET_ADD_ET_PAX,
  SET_ADD_ROOMS_ACTIVITY,
  SET_ADD_ROOMS_APARTMENT,
  SET_ADD_ROOMS_HOTEL,
  SET_ADD_ROOMS_TRANSFER,
  SET_CLEAR_LOCAL_STORAGE,
  SET_LOCAL_STORAGE,
  SET_NOTIFICATION_MESSAGE_PROMPT,
  // SET_QUOTES_ACTIVITIES,
  SET_QUOTES_REF,
  // SET_QUOTES_ROOMS,
  // SET_QUOTES_TRANSFERS
  SET_SEARCH_TYPE_LOCAL_STORAGE,
} from "../actionTypes/localStorageActionTypes";

export const getLocalStorage = (value: any) => {
  return {
    type: SET_LOCAL_STORAGE,
    payload: value,
  };
};

export const clearLocalStorageAction = () => {
  return {
    type: SET_CLEAR_LOCAL_STORAGE,
  };
};

// export const getQuoteRooms = (value: any) => {
//   return {
//     type: SET_QUOTES_ROOMS,
//     payload: value,
//   };
// };

// export const getQuoteTransfers = (value: any) => {
//   return {
//     type: SET_QUOTES_TRANSFERS,
//     payload: value,
//   };
// };

// export const getQuoteActivities = (value: any) => {
//   return {
//     type: SET_QUOTES_ACTIVITIES,
//     payload: value,
//   };
// };

export const getQuoteRef = (value: any) => {
  return {
    type: SET_QUOTES_REF,
    payload: value,
  };
};

export const getAddRoomsHotel = (value: any) => {
  return {
    type: SET_ADD_ROOMS_HOTEL,
    payload: value,
  };
};

export const getAddRoomsApartment = (value: any) => {
  return {
    type: SET_ADD_ROOMS_APARTMENT,
    payload: value,
  };
};

export const getAddRoomsActivity = (value: any) => {
  return {
    type: SET_ADD_ROOMS_ACTIVITY,
    payload: value,
  };
};

export const getAddRoomsTransfer = (value: any) => {
  return {
    type: SET_ADD_ROOMS_TRANSFER,
    payload: value,
  };
};

export const getAddETPaxAction = (value: any) => {
  return {
    type: SET_ADD_ET_PAX,
    payload: value,
  };
};

export const getAddEPPaxAction = (value: any) => {
  return {
    type: SET_ADD_EP_PAX,
    payload: value,
  };
};

export const getNotificationMessage = (value: any) => {
  return {
    type: SET_NOTIFICATION_MESSAGE_PROMPT,
    payload: value,
  };
};

export const getSearchSuggestionType = (value: any) => {
  return {
    type: SET_SEARCH_TYPE_LOCAL_STORAGE,
    payload: value,
  };
};